<template>
  <div class="form">
    <div class="from_all">
      <img class="logo" src="@/assets/logoMini.png" alt="">
      <h3 class="title_3">Добро пожаловать</h3>
      <p class="text_grey">Добро пожаловать в панель управления сетью COFFEEWAY</p>
        <template v-for="inp in inputs" :key="inp">
            <afinput-box :msgtext="msgtext" :params="inp" @action="inp.action" :showpas="showPassword">
              
              <img :src="showPassword ? require('@/assets/eye.svg') : require('@/assets/eye-off.svg')"
                   @click="togglePasswordVisibility" v-if="inp.type === 'password'" class="hidepas-img"/>
     
            </afinput-box>
            
        </template>
        <div class="msgBox" :class="{show :msgtext!='', hide :msgtext==''}">
              {{ msgtext == 'Ошибка авторизации' ? 'Неверный пароль' : 'Введите логин и пароль' }}
        </div>
    </div>
  </div>
</template>

<script>
import AfinputBox from "@/components/afinputBox";
export default {
  name: "AuthForm",
  props:{
    inputs:{
      type: Object
    },
    msgtext:{
      type: String
    }
  },
  components: {AfinputBox},
  data() {
      return {
          showPassword: false,
      }
  },
  methods:{
      togglePasswordVisibility() {
          this.showPassword = !this.showPassword;
          this.$emit('toggle-password', this.showPassword);
      },
  }
}
</script>

<style scoped>
.form {
  background-color: #181D27;
  width: 640px;
  height: 100vh;
  padding: 100px;
}
.from_all {
  display: flex;
  width: 440px;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
}
  .show{
    opacity: 1;
  }
  .hide{
    opacity: 0;
  }

.title_3 {
  font-size: 20px;
  font-weight: 600;
  color:white;
  margin: 15px 0;
}
.text_grey {
  color: #FFFFFF66;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 4px;
} 
.hidepas-img {
    position: absolute;
    cursor: pointer;
    width: 17px;
    right: 15px;
    top:36px;
}
.msgBox {
  transition: all .3s;
    height: 17px;
    margin-top: 15px;
    font-size: 14px;
    font-weight: 600;
    color: #EF5350;
}
  @media screen and (max-width: 850px) {
      .bgdivout {
          margin: 0 auto;
          position: fixed;
          right: auto;
          width: 280px;
      }
      .bgdivin {
          width: 280px;
      }
     
  }
</style>